module.exports = __webpack_public_path__ + "static/media/4.5195a47d.jpg";